import { Button } from 'components';
import { DeleteOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { ESTADOS } from 'constants/nombresCatalogos';
import { Row, Col } from 'antd';

export const ListadoDirecciones = (props) => {
  const entidades = useSelector(selectCatalogByName(ESTADOS));
  const emptyField = (field) => {
    return field === null || field === undefined;
  };

  const getMunicipio = (idMunicipio, nombreEstado) => {
    if (emptyField(idMunicipio)) return '';
    const municipiosEntidad =
      entidades.find((e) => e.nombreEstado === nombreEstado)?.municipios || [];
    return municipiosEntidad.find((e) => e.idMunicipio === idMunicipio)?.nombreMunicipio;
  };

  const directionDefine = (punto, nombreEstado) => {
    const municipio = getMunicipio(punto.idMunicipio, nombreEstado);
    let direccion = `${'Calle: '}${emptyField(punto.calle) ? 'Sin registro' : punto.calle}${' '}${
      emptyField(punto.numero) ? '' : punto.numero
    }${', Colonia: '}${emptyField(punto.colonia) ? 'Sin registro' : punto.colonia}${' CP: '}${
      emptyField(punto.codigoPostal) ? 'Sin registro' : punto.codigoPostal
    }${' '}${municipio}, ${nombreEstado}`;
    if (emptyField(punto.calle) && emptyField(punto.colonia) && emptyField(punto.codigoPostal)) {
      console.log('Calle vacia');
      direccion = `Municipio: ${getMunicipio(punto.idMunicipio, nombreEstado)}, ${nombreEstado}`;
    }
    return direccion;
  };

  const { listacordenadasSeleccionadas, nombreEstado, onDelete } = props;
  const lista = listacordenadasSeleccionadas.map((punto, index) => {
    return (
      <div className="padingBorder" key={`div_${index + 1}`}>
        <Row className="borderBot" key={`row_${index + 1}`}>
          <Col span={1} className="colorTitlINE">
            {index + 1}
          </Col>
          <Col span={18} className="titledirecciones">
            <p>{directionDefine(punto, nombreEstado)}</p>
          </Col>
          <Col span={2}>
            <Button
              className="eliminarBorde"
              icon={<DeleteOutlined className="icons-tbl-users" />}
              onClick={() => {
                onDelete(punto);
              }}
            />
          </Col>
        </Row>
      </div>
    );
  });
  return lista;
};
